<template>
    <v-tab-item :value="thisTab" class="fill-height">
        <v-layout column justify-center class="h-100">
            <div>
                <pages-head />
                <v-divider />
            </div>
            <div style="flex:1; overflow:hidden">
                <v-row no-gutters class="fill-height">
                    <v-col class="fill-height tabs-pages__side" cols="12" xl="" v-if="!mobile">
                        <pages-side v-model="form" @input="emit" />
                    </v-col>
                    <v-col class="fill-height" cols="12" xl="auto" v-if="!mobile">
                        <v-divider vertical />
                    </v-col>
                    <v-col class="fill-height tabs-pages__body" cols="12" xl="" :key="key" style="position:relative">
                        <pages-body v-if="isOn" v-model="form" @input="emit" />
                        <pages-tool v-if="mobile" v-model="form" @input="emit" />
                        <pages-edit v-if="mobile" />
                        <pages-list v-if="mobile" v-model="form" @input="emit" />
                    </v-col>
                    <v-col class="fill-height" cols="auto" v-if="!mobile">
                        <v-divider vertical />
                    </v-col>
                    <v-col class="fill-height tabs-pages__desc" cols="12" xl="" v-if="!mobile">
                        <pages-desc v-model="form" @input="emit" />
                    </v-col>
                </v-row>
            </div>
            <v-divider />
            <div class="v-btn-group flex-wrap my-12">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('prev')"
                >
                    <v-icon color="grey-6">mdi-chevron-left</v-icon>
                    <span class="grey-6--text"> 이전 단계 </span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="$emit('save')"><span>저장하기</span></v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { mapState } from "vuex";
import { initEmploymentForm } from "@/assets/variables";
import { TABS } from "../lib";

import PagesBody from "./pages/pages-body.vue";
import PagesDesc from "./pages/pages-desc.vue";
import PagesHead from "./pages/pages-head.vue";
import PagesSide from "./pages/pages-side.vue";
import PagesTool from "./pages/pages-tool.vue";
import PagesEdit from "./pages/pages-edit.vue";
import PagesList from "./pages/pages-list.vue";

const thisTab = TABS.PAGES.value;

export default {
    components: {
        PagesBody,
        PagesDesc,
        PagesHead,
        PagesSide,
        PagesTool,
        PagesEdit,
        PagesList,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
        tab: { type: String, default: TABS.BASIC.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentForm(),

        thisTab,
    }),
    computed: {
        ...mapState("employment/form/page", ["key"]),
        ...mapState("ui", { mobile: (store) => store.window.innerWidth < 1600 }),

        isOn() {
            return this.shows && this.tab == thisTab;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },

        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1600px) {
    .tabs-pages {
        &__desc,
        &__side {
            min-width: 320px;
            max-width: 320px;
        }
        &__body {
            max-width: calc(100vw - 320px - 1px - 1px - 320px);
        }
    }
}
</style>
